import React, { useState, useEffect } from "react";
import { getActiveAuthorizationCodes } from "../../../../service/profile/profile";
import { UserInfoSelector } from "../../../../store/reduxSelector";
const AuthorizationCodeStatus = () => {
  const [codes, setCodes] = useState([]);
  const [remainingTimes, setRemainingTimes] = useState([]);
  const user = UserInfoSelector();
  useEffect(() => {
    const fetchCodes = async () => {
      try {
        const response = await getActiveAuthorizationCodes(user);
        setCodes(response || []);
      } catch (error) {
        console.error("Failed to fetch authorization codes:", error);
      }
    };

    fetchCodes();
  }, [user]);

  useEffect(() => {
    const initialTimes = codes.map((c) => {
      const exp = new Date(c.expiration_date).getTime();
      const now = Date.now();
      return Math.max(Math.floor((exp - now) / 1000), 0);
    });
    setRemainingTimes(initialTimes);
  }, [codes]);

  useEffect(() => {
    const timer = setInterval(() => {
      setRemainingTimes((prev) => prev.map((r) => Math.max(r - 1, 0)));
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  if (!codes.length)
    return <span className="status-muted">No active codes</span>;

  return (
    <div
      className="supervisor-code-status-list"
      style={{ display: "flex", flexDirection: "column", gap: "6px" }}
    >
      {codes.map((code, index) => {
        const actionName = code.action_name;
        let statusText = "";
        const remaining = remainingTimes[index];
        const mins = Math.ceil(remaining / 60);

        if (code.used_date === null) {
          statusText = `Unused  · Expires in ${mins} min`;
        } else {
          if (remaining <= 0) {
            statusText = "Expired";
          } else {
            statusText = `In use · Expires in ${mins} min`;
          }
        }

        return (
          <div key={index} style={{ display: "flex", gap: "12px" }}>
            <span style={{ fontWeight: "bold" }}>Action:</span>
            <span>{actionName}</span>
            <span style={{ fontWeight: "bold", marginLeft: "12px" }}>
              Status:
            </span>
            <span>{statusText}</span>
          </div>
        );
      })}
    </div>
  );
};

export default AuthorizationCodeStatus;
